import { SVGAttributes } from 'react';

export default function (props: SVGAttributes<SVGElement>) {
    return (
        <svg width="29" height="29" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M10 13c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h9c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-9z" />
        </svg>
    );
}
